<template>
    <div class="answer-rating-form">
        <h2>Svara på omdöme</h2>
        <transition name="fade" mode="out-in">

            <div v-if="step == 1" key="1">
                <rating
                    :rating="selectedRating"
                    :company="company"
                    :maxHeight="true"
                />

                <text-area v-model="message" :label="'Svar'" :placeholder="'Här kan du formulera ett svar på omdömet'" />

                <div class="btn-wrap">
                    <atom-button :label="'Skicka'"
                            class="c-a-button--theme-primary"
                            @buttonClicked="submit()"
                    ></atom-button>
                </div>
            </div>

            <div v-if="step == 2" key="2">
                <div class="c-t-request__main" v-if="!loading && !error" key="content">
                    <div class="c-m-success-state">
                        <div class="c-m-success-state__inner">
                            <icon class="c-m-success-state__hero-icon" :icon="'sentiment_very_satisfied'" />
                            <p class="c-m-success-state__heading">Tack!</p>
                            <div class="c-m-success-state__body">Ditt svar har blivit registrerat.</div>
                        </div>
                    </div>
                </div>
                <div class="c-t-request__main" v-else-if="loading && !error" key="loading">
                    <loader class="c-m-loader--x-large"/>
                </div>
                <div class="c-t-request__main" v-else key="error-1">
                    <error-state></error-state>
                </div>
            </div>

        </transition>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import {
        SEND_ANSWER_FOR_ID,
        SET_ANSWER,
        GET_CONTENT,
        IS_LOADING,
        GET_ERROR
    } from '../../../../../../store/store-models/rating-model';

    import Icon from '../../../../atoms/AtomIcon.vue';
    import TextArea from '../../../../atoms/form/AtomTextarea.vue';
    import AtomButton from '../../../../atoms/AtomButton.vue';
    import Rating from '../../../../molecules/MoleculeRating.vue'

    import Loader from '../../../../molecules/MoleculeLoader.vue';
    import ErrorState from '../../../../molecules/MoleculeErrorState.vue';

    export default {
        components: {
            Rating,
            AtomButton,
            TextArea,
            Loader,
            ErrorState,
            Icon
        },
        props:{
            company: {
                default: {},
                type: Object
            },
            selectedRating: {
                default: {},
                type: Object
            },
        },
        data() {
            return {
                step: 1,
            }
        },
        computed:{
            ...mapGetters({
                rating: GET_CONTENT,
                loading: IS_LOADING,
                error: GET_ERROR
            }),
            message: {
                get(){
                    return this.rating.Answer;
                },
                set(value){
                    this.$store.commit(SET_ANSWER, value);
                }
            },
        },
        methods: {
            ...mapActions({
                sendAnswer: SEND_ANSWER_FOR_ID
            }),
            submit(){
                this.step++;
                this.$set(this.selectedRating, 'Answer', this.message)
                this.sendAnswer(this.selectedRating.RatId);
            }
        },
    }
</script>

<style scoped>
.company-wrap,
.rating-wrap{
    padding: 40px 0;
}

.rating-wrap{
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
}

.btn-wrap{
    text-align: center;
    margin-top:20px;
}

.fade-enter-active {
    transition: all .2s ease;
}
.fade-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter, .fade-leave-to{
    transform: translateX(10px);
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/organisms/my-pages-sections/company/profile/OrganismAnswerRatingForm.vue